var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVoir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85004 33L5.75004 26.11H7.27004L8.50004 30.63L9.72004 26.11H11.25L9.15004 33H7.85004ZM17.4941 29.57C17.4941 28.99 17.2941 28.5 16.8941 28.09C16.5041 27.68 16.0241 27.48 15.4541 27.48C14.8841 27.48 14.4041 27.68 14.0141 28.09C13.6241 28.5 13.4241 28.99 13.4241 29.57C13.4241 30.15 13.6241 30.64 14.0141 31.05C14.4041 31.45 14.8841 31.65 15.4541 31.65C16.0241 31.65 16.5041 31.45 16.8941 31.04C17.2941 30.63 17.4941 30.14 17.4941 29.57ZM11.9641 29.57C11.9641 28.59 12.3041 27.76 12.9741 27.07C13.6541 26.38 14.4841 26.03 15.4541 26.03C16.4341 26.03 17.2641 26.38 17.9341 27.07C18.6141 27.76 18.9541 28.59 18.9541 29.57C18.9541 30.54 18.6141 31.38 17.9341 32.07C17.2541 32.76 16.4241 33.1 15.4541 33.1C14.4841 33.1 13.6541 32.76 12.9741 32.07C12.3041 31.38 11.9641 30.54 11.9641 29.57ZM20.4766 33V26.11H21.9366V33H20.4766ZM26.6028 27.4H25.3228V29.34H26.5628C27.0928 29.34 27.4328 28.86 27.4328 28.37C27.4328 27.89 27.1128 27.4 26.6028 27.4ZM27.2428 30.56L28.9528 33H27.1928L25.6528 30.62H25.3228V33H23.8528V26.11H26.6728C27.4028 26.11 27.9728 26.33 28.3628 26.78C28.7628 27.22 28.9628 27.75 28.9628 28.37C28.9628 29.42 28.3628 30.32 27.2428 30.56Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19C22.4183 19 26 15.4183 26 11C26 6.58172 22.4183 3 18 3C13.5817 3 10 6.58172 10 11C10 15.4183 13.5817 19 18 19Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14C19.6569 14 21 12.6569 21 11C21 9.34315 19.6569 8 18 8C16.3431 8 15 9.34315 15 11C15 12.6569 16.3431 14 18 14Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20C9.28189 20 2 11 2 11C2 11 9.28189 2 18 2",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20C26.7181 20 34 11 34 11C34 11 26.7181 2 18 2",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoir);
export default __webpack_public_path__ + "static/media/icon-voir.047b7cec538dfae0a256e4195c196e2e.svg";
export { ForwardRef as ReactComponent };